module.exports = __webpack_public_path__ + "static/media/S (17).920e8bf6.jpg";